exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2a6II{font-weight:500;width:100%;text-align:left;color:var(--neutral--800);color:var(--neutral--800);border:none;padding:6px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;border-radius:var(--base--border-radius);border-radius:var(--base--border-radius);background:#fff}._2a6II:active, ._2a6II:hover{color:var(--base-color);color:var(--base-color);background:var(--neutral--100);background:var(--neutral--100)}._2wxc6{color:var(--neutral--800);color:var(--neutral--800);padding:5px 20px;border-radius:var(--base--border-radius);border-radius:var(--base--border-radius)}", ""]);

// exports
exports.locals = {
	"question": "_2a6II",
	"answer": "_2wxc6"
};